<div class="einzelrechte-matrix">
  @switch (state()) {
    @case ('loading') {
      <p class="einzelrechte-matrix__status" role="status">
        {{ 'userEdit.berechtigungen.loading' | translate }}
      </p>
    }
    @case ('error') {
      <div class="einzelrechte-matrix__error" role="alert">
        <mat-icon aria-hidden="true">error_outline</mat-icon>
        <span>{{ 'userEdit.berechtigungen.loadError' | translate }}</span>
      </div>
    }
    @case ('invitation') {
      <div class="einzelrechte-matrix__banner" role="note">
        <mat-icon aria-hidden="true">schedule</mat-icon>
        <span>{{ 'userEdit.berechtigungen.invitation' | translate: { name: userName() } }}</span>
      </div>
    }
    @case ('forbidden') {
      <div class="einzelrechte-matrix__banner" role="note">
        <mat-icon aria-hidden="true">lock</mat-icon>
        <span>{{ 'userEdit.berechtigungen.forbidden' | translate: { name: userName() } }}</span>
      </div>
    }
    @default {
      @if (selectedEntry(); as entry) {
        <div class="einzelrechte-matrix__toolbar">
          <mat-form-field appearance="fill" floatLabel="always" class="einzelrechte-matrix__project-field">
            <mat-label>{{ 'userEdit.berechtigungen.projectLabel' | translate }}</mat-label>
            <mat-select
              [value]="entry.projectId"
              [aria-label]="'userEdit.berechtigungen.projectAriaLabel' | translate"
              (selectionChange)="selectProject($event.value)"
            >
              @for (project of projects(); track project.projectId) {
                <mat-option [value]="project.projectId">{{ project.projectName }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (canReset()) {
            <button type="button" class="einzelrechte-matrix__reset" [disabled]="disabled()" (click)="resetToRole()">
              <mat-icon aria-hidden="true">restart_alt</mat-icon>
              <span>{{ 'userEdit.berechtigungen.reset' | translate }}</span>
            </button>
          }
        </div>

        <div class="einzelrechte-matrix__banner" role="note">
          @switch (readOnlyReason()) {
            @case ('SELF') {
              <mat-icon aria-hidden="true">lock</mat-icon>
              <span>{{ 'userEdit.berechtigungen.self' | translate }}</span>
            }
            @case ('ADMIN_TARGET') {
              <mat-icon aria-hidden="true">lock</mat-icon>
              <span>
                {{ 'userEdit.berechtigungen.adminTarget' | translate: { role: tenantRoleLabel(), name: userName() } }}
              </span>
            }
            @default {
              <mat-icon aria-hidden="true">shield</mat-icon>
              <span>
                {{ 'userEdit.berechtigungen.rolePrefix' | translate }}
                <strong>
                  @for (key of roleLabelKeys(); track $index) {
                    {{ key | translate }}{{ $last ? '' : ', ' }}
                  }
                </strong>
                {{ 'userEdit.berechtigungen.roleSuffix' | translate: { project: entry.projectName } }}
              </span>
            }
          }
        </div>

        <div class="einzelrechte-matrix__sections">
          @for (section of sections(); track section.id) {
            <section class="einzelrechte-matrix__section">
              <header class="einzelrechte-matrix__section-header">
                <span class="einzelrechte-matrix__section-icon" aria-hidden="true">
                  <mat-icon>{{ section.icon }}</mat-icon>
                </span>
                <h3 class="einzelrechte-matrix__section-label">{{ section.labelKey | translate }}</h3>
              </header>
              <ul class="einzelrechte-matrix__list">
                @for (row of section.rows; track row.permission) {
                  <li class="einzelrechte-matrix__item" [attr.data-permission]="row.permission">
                    <mat-checkbox
                      [checked]="row.checked"
                      [disabled]="!editable() || row.locked || disabled()"
                      [aria-describedby]="row.badgeKey ? badgeIdPrefix + row.permission : ''"
                      (change)="toggle(row.permission, $event.checked)"
                    >
                      {{ row.labelKey ? (row.labelKey | translate) : row.permission }}
                    </mat-checkbox>
                    @if (row.locked && editable()) {
                      <mat-icon
                        class="einzelrechte-matrix__lock"
                        tabindex="0"
                        role="img"
                        [attr.aria-label]="'userEdit.berechtigungen.readLocked' | translate"
                        [matTooltip]="'userEdit.berechtigungen.readLocked' | translate"
                      >
                        lock
                      </mat-icon>
                    }
                    @if (row.badgeKey) {
                      <span
                        [id]="badgeIdPrefix + row.permission"
                        class="einzelrechte-matrix__badge"
                        [class.einzelrechte-matrix__badge--revoked]="row.badgeKey === revokedKey"
                      >
                        {{ row.badgeKey | translate }}
                      </span>
                    }
                  </li>
                }
              </ul>
            </section>
          }
        </div>
      } @else {
        <div class="einzelrechte-matrix__banner" role="note">
          <mat-icon aria-hidden="true">folder_off</mat-icon>
          <span>{{ 'userEdit.berechtigungen.empty' | translate: { name: userName() } }}</span>
        </div>
      }
    }
  }
</div>
